function Dipespinviertepe(){
     return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Invierte.pe y Gestión de Inversiones Públicas 
                    brinda una formación integral y actualizada en el marco del Sistema Nacional 
                    de Programación Multianual y Gestión de Inversiones, desarrollando competencias 
                    técnicas para la identificación, formulación, evaluación y seguimiento de proyectos 
                    de inversión pública.
               </p>
               <p>
                    El programa aborda aspectos clave como la programación multianual de inversiones, 
                    elaboración de fichas técnicas y estudios de preinversión, evaluación social de proyectos, 
                    gestión de riesgos, seguimiento y cierre de inversiones, promoviendo una gestión 
                    orientada a resultados y al cierre efectivo de brechas.
               </p>

                <ul>
                    <h1> Objetivo Específico </h1>
                    <ul>
                        <li>
                            Desarrollar competencias técnicas en los participantes para aplicar 
                            correctamente la normativa y metodología del sistema Invierte.pe, 
                            formulando y gestionando proyectos de inversión pública de manera 
                            eficiente, sostenible y alineada a las prioridades estratégicas del Estado.
                        </li>
                    </ul>
                </ul>
            </div>

            <div className="metedologia">
                <img 
                    src='/uploads/curs_inversion_publica.jpg' 
                    alt='logo-de-metodologia' 
                    className='logo-metodologia'
                />
                
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>Escuela de Gerencia y Gestión S.A.C</p>
                        <p>📱 Teléfonos y WhatsApp: 913376365 / 948251685</p>
                        <p>📧 Correos: esscuelag@gmail.com | capacita@escuelag.com</p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Sistema Invierte.pe </li>
                    <li> 2. Programación Multianual de Inversiones </li>
                    <li> 3. Formulación y Evaluación de Proyectos </li>
                    <li> 4. Evaluación Social y Gestión de Riesgos </li>
                    <li> 5. Seguimiento y Control de Inversiones </li>
                    <li> 6. Cierre y Sostenibilidad de Proyectos </li>
                </ul>
            </div>
        </div>
    );
}
export default Dipespinviertepe
